import { Tabs } from "antd";
import React, { useState } from "react";
import MainPurchaseReport from "./purchase/MainPurchaseReport";
import MainSalesReport from "./sales/MainSalesReport";
import MainStockReport from "./stock/MainStockReport";
import MainCustomerDuesReport from "./customerLedger/MainCustomerLedger";
import MainPayableReport from "./supplierLedger/MainSupplierLedger";
import MainCollectionReport from "./collection/MainCollectionReport";
import MainSalesTargetReport from "./salesTarget/MainSalesTargetReport";
import MainSupplierLedger from "./supplierLedger/MainSupplierLedger";
import MainCustomerLedger from "./customerLedger/MainCustomerLedger";

export default function FinancialSummary() {
  const [tabChange, setTabChange] = useState(null);

  const handleTabChange = (value) => {
    setTabChange(value);
  };
  const items = [
    {
      key: "Purchase & Receive",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Purchase & Receive Report
        </div>
      ),
      children: <MainPurchaseReport />,
    },
    {
      key: "Sales Report",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Sales Report
        </div>
      ),
      children: <MainSalesReport />,
    },
    {
      key: "Supplier Ledger Report",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Supplier Ledger Report
        </div>
      ),
      children: <MainSupplierLedger />,
    },
    {
      key: "Customer Ledger Report",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Customer Ledger Report
        </div>
      ),
      children: <MainCustomerLedger />,
    },
    // {
    //   key: "Stock Flow Report",
    //   label: (
    //     <div className="text-center" style={{ color: "#46604A" }}>
    //       Stock Flow Report
    //     </div>
    //   ),
    //   children: <MainStockReport />,
    // },
    // {
    //   key: "Sales Target Report",
    //   label: (
    //     <div className="text-center" style={{ color: "#46604A" }}>
    //       Sales Target Report
    //     </div>
    //   ),
    //   children: <MainSalesTargetReport />,
    // },
  ];
  return (
    <>
      <div className="consultationDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>SALES, PURCHASE & DUES REPORT</h5>
        </div>
        <div className="consultationDashboardContainer shadow-sm rounded">
          <Tabs
            onChange={handleTabChange}
            className="px-4 mt-4 custom-tabs"
            defaultActiveKey="Purchase Report"
            items={items}
          />
        </div>
      </div>
    </>
  );
}
